module.exports = __webpack_public_path__ + "img/EnglishCard2.e363379c.jpg";